import { type Location, type RouteObject, matchRoutes } from "react-router-dom"

export const useCurrentRoute = (
    routes: string[],
    location: Location,
): RouteObject | undefined => {
    const result = matchRoutes(
        routes.map(path => ({ path })),
        location,
    )

    return result?.[0].route
}
